// @flow

import {ApiClient} from 'docs/data';
import {
  videosLoading,
  videosLoaded,
  videosError,
} from 'docs/data/videos/VideosReducer';
import type {Dispatcher} from 'docs/data';
import type {VideosEvent} from 'docs/data/videos/VideosReducer';
import {transformAllVideos} from 'docs/server/transformers';

export const loadAllVideos = (
  api: ApiClient,
  dispatch: Dispatcher<VideosEvent>,
) => async () => {
  dispatch(videosLoading());
  try {
    const response = await api.getAllVideos();
    const videos = transformAllVideos(response);
    dispatch(videosLoaded(videos));
  } catch (e) {
    dispatch(videosError(e));
  }
};
